/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SectionTitle from '@components/uyirnokkam/UymSectionTitle';
import config from '@config';

/* Services */

/**
 * Renders the Card Circular 2 Column Group Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} lang - Current User Language.
 * @param {string} region - Current User Country.
 * @param sectionContent.region
 * @param sectionContent.lang
 * @returns {ReactElement} UymImportance Card component
 */
const UymImportance = ({ sectionContent, region, lang }) => {
  return (
    <Box
      width={'100%'}
      h="100%"
      mx="auto"
      background={{
        base: 'none',
        md: `url(${config.imgPath}/d/46272/1734011373-uym_prog_importance_bg.png) no-repeat`,
        "2xl": `url(${config.imgPath}/d/46272/1737038269-uym_prog_importance_bg1.png) no-repeat`
      }}
      bgPosition={'left 97px !important'}
      pb={{base:'0', md:'40px'}}
      mb={{base:'0px'}}
    >
      <Box w={{base:'290px', md:'100%'}} m="0 auto" pt={{ base: '10px', md: '10px' }} pb={{ base: '20px', md: '30px' }}>
        <SectionTitle titleObj={sectionContent[0]} lang={lang} />
      </Box>
      <Box
        display="flex"
        flexWrap="wrap"
        gridGap={10}
        justifyContent="center"
        textAlign="center"
        my={4}
      >
        {sectionContent[1]?.cards?.map((section, index) => {
          return (
            <Box
              display="flex"
              flexDirection="column"
              key={nanoid()}
              mx="30px"
              maxWidth={{ base: '90%', md: index == 0 ? '290px' : '320px', "2xl": index == 0 ? '290px' : '320px' }}
            >
              <Box mb={{ base: 4, md: 6 }}>
                <LazyLoadImageComponent
                  src={section.thumbnail?.url}
                  title={section.thumbnail?.title}
                  alt={section.thumbnail?.alt}
                  maxWidth={{ base: 190, md: 270 }}
                />
              </Box>
              {section.title && (
                <Box
                  as="h2"
                  fontFamily="MuktaMlalar"
                  fontSize={{ base: '16px', md: '18px' }}
                  color="#000000"
                  lineHeight={{ base: '20px', md: '25px' }}
                  mb={4}
                >
                  {section.title}
                </Box>
              )}
              <Box
                as="p"
                fontFamily="MuktaMlalar"
                fontSize="18px"
                color="#000000"
                maxW={{base:'250px', md:'320px'}}
              >
                <StructuredTextParser
                  str={render(section.description)}
                  region={region}
                  lang={lang}
                  fontSize={'18px'}
                  textAlign="center"
                  fontWeight="600"
                  mt="0"
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default UymImportance;
